import {Utility} from "./utility";

export const StateCore = {

	createdStates: {},

	returnMethods: (Id, requestedKey=false) => {
		return {
			/**
			 * Will return you the Store you just created
			 * @returns {*}
			 */
			Get: () => {
				if (requestedKey) return StateCore.createdStates[Id][requestedKey];
				else return StateCore.createdStates[Id];
			},

			/**
			 * Will select a value from your store
			 * @param key
			 * @param index
			 * @param callback
			 * @returns {*}
			 * @constructor
			 */
			Select: (key, index, callback) => {
				// get the property
				const property = Utility.getNestedProperty(StateCore.createdStates[Id], key);

				// if all args are passed
				if (key && index) {
					// check if key exists
					if (property !== undefined) {
						if (callback !== undefined) return callback(property);
						else return property[index];
					}
					else console.error(`State Error :: Property (${key}) is undefined and cannot be fetched`);
				}

				// just the first arg is passed
				else {
					// check if key exists
					if (property !== undefined) {
						if (callback !== undefined) return callback(property);
						else return property;
					}
					else console.error(`State Error :: Property (${key}) is undefined and cannot be fetched`);
				}
			},

			/**
			 * Will update a property inside your store
			 * @param {String} key
			 * @param {*} value
			 * @param {Function} callback
			 * @returns {*}
			 * @constructor
			 */
			Commit: (key, value=null, callback=null) => {
				const property = Utility.getNestedProperty(StateCore.createdStates[Id], key);
				if (property !== undefined) {
					if (callback) return callback(property);
					else {
						Utility.setNestedProperty(StateCore.createdStates[Id], key, value);
						return StateCore.createdStates[Id];
					}
				}
				else console.error(`State Error :: cannot set property (${key}) of undefined`);
			},
		};
	},

	CreateStore: (data) => {
		const Id = Utility.getRandomString(5, "UPPERCASE");
		StateCore.createdStates[Id] = data;

		return {...StateCore.returnMethods(Id)};
	},

};